import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SnackbarProvider } from 'notistack';
import { store, persistor } from './createStore';
import Routes from './routes';
import isIE from './Components/IeCheck/isIE';
import IECheck from './Components/IeCheck/IeCheck';
import { Helmet } from 'react-helmet';
import { QueryClient, QueryClientProvider } from 'react-query';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});

function App() {
  const VWO_ACCOUNT_ID = 584350;
  const VWO_SETTINGS_TOLERANCE = 2000;
  const VWO_LIBARY_TOLERANCE = 2500;
  const VWO_HIDE_ELEMENT = 'body';
  const mappingReturn = {
    true: <IECheck />,
    false: (
      <Suspense fallback={<h1> Carregando... </h1>}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <SnackbarProvider>
              <QueryClientProvider client={client}>
                <Routes />
              </QueryClientProvider>
            </SnackbarProvider>
          </PersistGate>
        </Provider>
      </Suspense>
    ),
  };

  return (
    <>
      <Helmet>
        <script type="text/javascript">
          {`window._vwo_code = window._vwo_code || (function(){
          var account_id=${VWO_ACCOUNT_ID},
          settings_tolerance=${VWO_SETTINGS_TOLERANCE},
          library_tolerance=${VWO_LIBARY_TOLERANCE},
          use_existing_jquery=false,
          is_spa=1,
          hide_element='${VWO_HIDE_ELEMENT}',
          f=false,d=document,code={use_existing_jquery:function(){return use_existing_jquery;},library_tolerance:function(){return library_tolerance;},finish:function(){if(!f){f=true;var a=d.getElementById('_vis_opt_path_hides');if(a)a.parentNode.removeChild(a);}},finished:function(){return f;},load:function(a){var b=d.createElement('script');b.src=a;b.type='text/javascript';b.innerText;b.onerror=function(){_vwo_code.finish();};d.getElementsByTagName('head')[0].appendChild(b);},init:function(){
          window.settings_timer=setTimeout(function () {_vwo_code.finish() },settings_tolerance);var a=d.createElement('style'),b=hide_element?hide_element+'{opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;}':'',h=d.getElementsByTagName('head')[0];a.setAttribute('id','_vis_opt_path_hides');a.setAttribute('type','text/css');if(a.styleSheet)a.styleSheet.cssText=b;else a.appendChild(d.createTextNode(b));h.appendChild(a);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&f='+(+is_spa)+'&r='+Math.random());return settings_timer; }};window._vwo_settings_timer = code.init(); return code; }());`}
        </script>
      </Helmet>
      {mappingReturn[isIE(document)]}
    </>
  );
}

export default App;
